// @ts-nocheck
import React from 'react';
import { useSelector } from 'react-redux';

// i18n
import { useTranslation } from 'react-i18next';

// material ui
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
// icons
import SearchIcon from '@material-ui/icons/Search';
import CropFreeIcon from '@material-ui/icons/CropFree';
// components
import Autocomplete from '@material-ui/lab/Autocomplete';
import ButtonWithLoader from '../../../../commons/containers/ButtonWithLoader';
import DatePicker from '../../../../commons/components/DatePicker';
import MultipleSelector from '../../../../commons/components/MultipleSelector';
import { sortArrayBy } from '../../../../utils/arrayFunctions';
import TableActionMenu from '../../../../commons/components/TableActionMenu';
import { getAccessPolicy, getCurrentSubdomain } from 'utils/accessPolicy';
import exportExcel from '../../../../utils/services/exportExcel';
import { Button } from '@material-ui/core';
import { shouldUseCallOffInAutomationModals } from 'utils/tenantFeatures';

function Filters(props) {
  const {
    classes,
    filter,
    onFilterChange,
    objects,
    clearFilters,
    filterProcesses,
    toggleEmployeeCostsModal,
    socketId,
    toggleAutoScanner,
    hasAutomation,
    role,
  } = props;
  const accessPolicy = getAccessPolicy({
    subdomain: getCurrentSubdomain(),
    roleName: role?.name,
  });
  const {
    canExport,
    canImportEmployeeCosts,
    canScan,
  } = accessPolicy.processes;

  const { t } = useTranslation();
  const shouldFilterByCallOff = hasAutomation && shouldUseCallOffInAutomationModals();

  const statusOptions = [
    { value: 'open', label: t("Open") },
    { value: 'closed', label: t("Closed") },
  ];

  const employeeOptions = Object.values(objects.employees).map((emp) => ({
    label: emp.entity().name,
    value: emp.id,
  }));

  const exportButtonState = useSelector((state) => state.app.exportExcelButton);

  return (
    <Grid item xs={12}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card className={classes.root}>
            <CardHeader title={t('Filter')} />
            <CardContent>
              <Grid container spacing={3} className={classes.container}>
                <Grid container item spacing={3}>
                  <Grid item sm={4} xs={12}>
                    <DatePicker
                      inputId="fromDate"
                      label={t('From')}
                      fullWidth
                      value={filter.fromDate}
                      onChange={onFilterChange}
                    />
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <DatePicker
                      inputId="toDate"
                      label={t('To')}
                      fullWidth
                      value={filter.toDate}
                      onChange={onFilterChange}
                    />
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <TextField
                      fullWidth
                      type="number"
                      id="number"
                      label="N°"
                      value={filter.number}
                      onChange={onFilterChange}
                    />
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="process-category-label">{t('Category')}</InputLabel>
                      <Select
                        labelId="process-category-label"
                        fullWidth
                        value={filter.processCategoryId}
                        onChange={onFilterChange}>
                        <MenuItem id="processCategoryId" value="">
                          {t('All')}
                        </MenuItem>
                        {Object.values(objects.processCategories).map((processCategory) => (
                          <MenuItem
                            key={`process-category-filter-option-${processCategory.id}`}
                            id="processCategoryId"
                            value={processCategory.id}>
                            {processCategory.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <Autocomplete
                      value={
                        filter.processTypeId &&
                        Object.values(objects.processTypes).find(
                          (processType) => processType.id === filter.processTypeId,
                        )
                      }
                      id="autocomplete-processType-filters-processes"
                      options={sortArrayBy(Object.values(objects.processTypes), 'ASC', 'name')}
                      getOptionLabel={(processType) => processType?.name?.toLowerCase() || ''}
                      renderInput={(params) => (
                        <TextField
                          style={{ margin: 0 }}
                          {...params}
                          label={t('Process type')}
                          margin="normal"
                        />
                      )}
                      onChange={(event, newValue) => {
                        const e = {
                          autocomplete: true,
                          input: 'processTypeId',
                          value: newValue ? newValue.id : '',
                        };
                        onFilterChange(e);
                      }}
                    />
                  </Grid>

                  <Grid item sm={4} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="work-shift-type-label">{t('Shift')}</InputLabel>
                      <Select
                        labelId="work-shift-type-label"
                        fullWidth
                        value={filter.workShiftTypeId}
                        onChange={onFilterChange}>
                        <MenuItem id="workShiftTypeId" value="">
                          {t('All')}
                        </MenuItem>
                        {Object.values(objects.workShiftTypes).map((workShiftType) => (
                          <MenuItem
                            key={`work-shift-type-filter-option-${workShiftType.id}`}
                            id="workShiftTypeId"
                            value={workShiftType.id}>
                            {workShiftType.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <Autocomplete
                      value={filter.productId && objects.products[filter.productId]}
                      id="autocomplete-product-filters-processes"
                      options={sortArrayBy(Object.values(objects.products), 'ASC', 'name')}
                      getOptionLabel={(product) => {
                        if (!product) return '';
                        const name = product.name?.toLowerCase() || '';
                        const code = product.code ? ` (${product.code})` : '';
                        return `${name}${code}`;
                      }}
                      renderInput={(params) => (
                        <TextField
                          style={{ margin: 0 }}
                          {...params}
                          label={t('Product')}
                          margin="normal"
                        />
                      )}
                      onChange={(event, newValue) => {
                        const e = {
                          autocomplete: true,
                          input: 'productId',
                          value: newValue ? newValue.id : '',
                        };
                        onFilterChange(e);
                      }}
                    />
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <Autocomplete
                      value={
                        filter.status &&
                        statusOptions.filter((opt) => filter.status === opt.value)[0]
                      }
                      id="autocomplete-status-filters-processes"
                      options={statusOptions}
                      getOptionLabel={(statusOpt) => statusOpt && statusOpt.label}
                      renderInput={(params) => (
                        <TextField
                          style={{ margin: 0 }}
                          {...params}
                          label={t('Status')}
                          margin="normal"
                        />
                      )}
                      onChange={(event, newValue) => {
                        const e = {
                          autocomplete: true,
                          input: 'status',
                          value: newValue ? newValue.value : '',
                        };
                        onFilterChange(e);
                      }}
                    />
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <Autocomplete
                      value={filter.equipmentId && objects.equipments[filter.equipmentId]}
                      id="autocomplete-fruit-filters-lots"
                      options={sortArrayBy(Object.values(objects.equipments), 'ASC', 'name')}
                      getOptionLabel={(equipment) => equipment?.name?.toLowerCase() || ''}
                      renderInput={(params) => (
                        <TextField
                          style={{ margin: 0 }}
                          {...params}
                          label={t('Equipment')}
                          margin="normal"
                        />
                      )}
                      onChange={(event, elem) => {
                        const e = {
                          autocomplete: true,
                          input: 'equipmentId',
                          value: elem?.id || '',
                        };
                        onFilterChange(e);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <MultipleSelector
                      id="employeeIds"
                      selectedValues={filter.employeeIds}
                      options={employeeOptions}
                      onChange={onFilterChange}
                      label={t('Staff')}
                      whereNotOptionLabel={t('No staff')}
                    />
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <Autocomplete
                      value={
                        filter.supplierId &&
                          objects.suppliers &&
                          objects.suppliers[filter.supplierId]
                          ? objects.suppliers[filter.supplierId]
                          : null
                      }
                      id="autocomplete-supplier-filters-processes"
                      options={
                        objects.suppliers
                          ? sortArrayBy(Object.values(objects.suppliers), 'ASC', 'id').filter(
                            (supplier) => supplier && supplier.id != null,
                          )
                          : []
                      }
                      getOptionLabel={(supplier) => {
                        if (!supplier || supplier.id == null) return '';
                        const entity = objects.entities && objects.entities[supplier.entityId];
                        return entity && entity.name ? entity.name : `Supplier ${supplier.id}`;
                      }}
                      renderInput={(params) => (
                        <TextField
                          style={{ margin: 0 }}
                          {...params}
                          label={t('Supplier')}
                          margin="normal"
                        />
                      )}
                      onChange={(event, elem) => {
                        const e = {
                          autocomplete: true,
                          input: 'supplierId',
                          value: elem?.id || '',
                        };
                        onFilterChange(e);
                      }}
                    />
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    {shouldFilterByCallOff ? (
                      <TextField
                        fullWidth
                        id="callOff"
                        label="CallOff"
                        value={filter.callOff}
                        onChange={onFilterChange}
                      />
                    ) : (
                      <Autocomplete
                        value={
                          filter.receiptLotId &&
                            objects.receiptLots &&
                            objects.receiptLots[filter.receiptLotId]
                            ? objects.receiptLots[filter.receiptLotId]
                            : null
                        }
                        id="autocomplete-receiptLot-filters-processes"
                        options={
                          objects.receiptLots
                            ? sortArrayBy(
                              Object.values(objects.receiptLots),
                              'DESC',
                              'number',
                            ).filter((receiptLot) => receiptLot && receiptLot.number != null)
                            : []
                        }
                        getOptionLabel={(receiptLot) => {
                          if (!receiptLot || receiptLot.number == null) return '';
                          return String(receiptLot.number);
                        }}
                        renderInput={(params) => (
                          <TextField
                            style={{ margin: 0 }}
                            {...params}
                            label={t('Lot number')}
                            margin="normal"
                          />
                        )}
                        onChange={(event, elem) => {
                          const e = {
                            autocomplete: true,
                            input: 'receiptLotId',
                            value: elem?.id || '',
                          };
                          onFilterChange(e);
                        }}
                      />
                    )}
                  </Grid>
                </Grid>
                <Grid item container spacing={3} justifyContent="flex-end">
                  <Grid item xs={12} sm={4} md={3}>
                    <ButtonWithLoader
                      fullWidth
                      onClick={clearFilters}
                      autoFocus
                      buttonId="get-process"
                      className={classes.filterButton}
                      size="small">
                      {t('Clear')}
                    </ButtonWithLoader>
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <ButtonWithLoader
                      fullWidth
                      onClick={filterProcesses}
                      autoFocus
                      buttonId="get-process"
                      className={classes.filterButton}
                      size="small"
                      startIcon={<SearchIcon />}>
                      {t('Search')}
                    </ButtonWithLoader>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          {(canImportEmployeeCosts || canExport) && (
            <TableActionMenu
              menuItems={[
                ...(canImportEmployeeCosts
                  ? [
                    {
                      label: t('Import'),
                      listItems: [
                        {
                          label: t('Company employee costs'),
                          onClick: toggleEmployeeCostsModal,
                        },
                      ],
                    },
                  ]
                  : []),
                ...(canExport
                  ? [
                    {
                      label: t('Export'),
                      listItems: [
                        {
                          label: t('Excel file'),
                          onClick: exportExcel,
                          params: [
                            { ...filter, hasAutomation },
                            'processes/export',
                            'Procesos',
                            socketId,
                          ],
                          disabled: !exportButtonState,
                        },
                      ],
                    },
                  ]
                  : []),
              ]}
            />
          )}

          {hasAutomation && canScan ? (
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={toggleAutoScanner}
              startIcon={<CropFreeIcon />}
              style={{ height: 'fit-content', marginTop: '16px' }}
            >
              {t('scanner_button')}
            </Button>
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Filters;
